import { render } from "./KPCard.vue?vue&type=template&id=649033b7&scoped=true"
import script from "./KPCard.vue?vue&type=script&lang=js"
export * from "./KPCard.vue?vue&type=script&lang=js"

import "./KPCard.vue?vue&type=style&index=0&id=649033b7&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src198257980/src/impact-vuejs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-649033b7"]])

export default __exports__